import { FC, useEffect } from "react";
import CardComponent from "../../common/components/card/card.component";
import HeadingComponent from "../../common/components/heading/heading.component";
import useDocumentTitle from "../../common/hooks/use-document-title";
import { useAppContext } from "../../context/app.context";
import appTranslationsHelper from "../../languages/app-translations.helper";

const RouteNotFoundComponent: FC = () => {
  const documentTitleTranslations =
    appTranslationsHelper.getDocumentTitleTranslations();

  useDocumentTitle(documentTitleTranslations.routeNotFound);

  const { setBreadcrumbs } = useAppContext();

  useEffect(() => {
    setBreadcrumbs([]);
  }, []);

  const translations = appTranslationsHelper.getRouteNotFoundTranslations();

  return (
    <div className="not_found">
      <div className="not_found_message">
        <HeadingComponent title={translations.headingText} />
        <CardComponent>{translations.message}</CardComponent>
      </div>
    </div>
  );
};

export default RouteNotFoundComponent;
